
/** Qwik City Plan */

/** Qwik City ServerPlugins (0) */
export const serverPlugins = [
];

/** Qwik City Routes (6) */
export const routes = [
  [ "finiteScroll/", [ ()=>import("/usr/src/app/src/routes/finiteScroll/index") ] ],
  [ "html/", [ ()=>import("/usr/src/app/src/routes/html/index") ] ],
  [ "ping/", [ ()=>import("/usr/src/app/src/routes/ping/index") ] ],
  [ "test/", [ ()=>import("/usr/src/app/src/routes/test/index") ] ],
  [ "dev/[...catchall]", [ ()=>import("/usr/src/app/src/routes/dev/[...catchall]/index") ] ],
];

/** Qwik City Menus (0) */
export const menus = [
];

/** Qwik City Entries Entry */
export const e = () => import("@qwik-city-entries");

export const trailingSlash = true;
export const basePathname = "/";
export const cacheModules = true;
export default { routes, serverPlugins, menus, trailingSlash, basePathname, cacheModules };